/**
 * Chaves do "lembrar login" — devem sobreviver ao logout (localStorage.clear).
 */
export const LS_LOGIN_REMEMBER = "gescomex_login_remember";
export const LS_LOGIN_USERNAME = "gescomex_login_username";
export const LS_LOGIN_PASSWORD_ENC = "gescomex_login_password_enc";

export function snapshotLoginRemember() {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  const remember = window.localStorage.getItem(LS_LOGIN_REMEMBER);
  if (remember !== "true") {
    return null;
  }
  return {
    remember,
    username: window.localStorage.getItem(LS_LOGIN_USERNAME),
    passwordEnc: window.localStorage.getItem(LS_LOGIN_PASSWORD_ENC),
  };
}

export function restoreLoginRemember(snapshot) {
  if (!snapshot || snapshot.remember !== "true") {
    return;
  }
  window.localStorage.setItem(LS_LOGIN_REMEMBER, snapshot.remember);
  if (snapshot.username != null) {
    window.localStorage.setItem(LS_LOGIN_USERNAME, snapshot.username);
  }
  if (snapshot.passwordEnc != null) {
    window.localStorage.setItem(LS_LOGIN_PASSWORD_ENC, snapshot.passwordEnc);
  }
}

/**
 * Equivalente ao logout com `localStorage.clear()`:
 * apaga todas as chaves do storage e, em seguida, restaura só o "lembrar login"
 * (se estava ativo). O clear completo continua obrigatório para limpar sessão,
 * user, rotas, etc.
 */
export function clearLocalStoragePreservingLoginRemember() {
  const snap = snapshotLoginRemember();
  window.localStorage.clear();
  restoreLoginRemember(snap);
}
